module.exports = __webpack_public_path__ + "img/baner6.68a3bf76.png";